import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { COOKIE_UI } from "../data/privacy";

const KEY = "jonaren_cookie_consent";

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

const CookieConsent = () => {
  const { lang } = useLang();
  const t = COOKIE_UI[lang];
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(!getConsent()), 900);
    const onOpen = () => setVisible(true);
    window.addEventListener("open-cookie-settings", onOpen);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("open-cookie-settings", onOpen);
    };
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible || pathname.startsWith("/admin")) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6 animate-fade-up" role="dialog" aria-live="polite" aria-label={t.title} data-testid="cookie-banner">
      <div className="mx-auto flex max-w-5xl flex-col gap-5 rounded-2xl border border-slate-200 bg-white/95 p-5 shadow-2xl shadow-brand-navy/20 backdrop-blur sm:p-6 lg:flex-row lg:items-center lg:gap-8">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-teal/10 text-brand-teal"><Cookie className="h-6 w-6" /></span>
        <div className="flex-1">
          <p className="font-heading text-lg font-bold text-brand-navy">{t.title}</p>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            {t.text}{" "}
            <Link to="/privacy" className="font-semibold text-brand-teal underline-offset-2 hover:underline" data-testid="cookie-privacy-link">{t.link}</Link>.
          </p>
        </div>
        <div className="flex flex-wrap gap-3 lg:shrink-0">
          <button type="button" onClick={() => decide("declined")} className="btn-outline h-11" data-testid="cookie-decline-button">{t.decline}</button>
          <button type="button" onClick={() => decide("accepted")} className="btn-primary h-11 bg-brand-orange text-white hover:bg-orange-600" data-testid="cookie-accept-button">{t.accept}</button>
        </div>
        <button type="button" onClick={() => decide("declined")} className="absolute end-3 top-3 rounded-md p-1 text-slate-400 hover:text-slate-600 lg:hidden" aria-label="Close"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
};

export default CookieConsent;
